import axios from 'axios';
import store from '@/store';
import queryString from 'query-string';
import { debounce } from 'lodash';
const qs = require('qs');
const USER_TOKEN_HEADER = 'unionGlobal_project_jwt_user_token';
const RELATIVE_APPLICATION_API = /^\/(?:api|common|v1)\//;

const loading = () => {
  store.dispatch('layout/updateIsLoading', { isLoading: true });
};
const loaded = debounce(() => {
  store.dispatch('layout/updateIsLoading', { isLoading: false });
}, 500);

const verboseLanguage = debounce((request) => {
  console.debug('Accept-Language :: ', request.headers['Accept-Language']);
}, 400);

const NETWORK_ERROR_STATUS = 0;
const createNetworkErrorResponse = (error = {}) => ({
  status: NETWORK_ERROR_STATUS,
  data: null,
  headers: {},
  config: error.config ?? {},
  request: error.request ?? null,
  isNetworkError: true,
  errorCode: error.code ?? '',
  errorMessage: error.message ?? ''
});

class ServiceExec {
  $axios;
  constructor() {
    this.$axios = axios.create();
    this.$axios.interceptors.request.use(this.handleRequest);
    this.$axios.interceptors.response.use(this.handleSuccess, this.handleError);
  }

  handleRequest(request) {
    const shouldSkipLoading = Boolean(request.notLoading ?? request.params?.notLoading);
    if (!shouldSkipLoading) {
      loading(true);
    }
    let korWeight = 0.1;
    let vnWeight = 0.1;

    if (store.getters['locale/getLocale'] === 'ko') {
      korWeight = 0.8;
      vnWeight = 0.7;
    } else {
      korWeight = 0.7;
      vnWeight = 0.8;
    }
    request.headers['Accept-Language'] = `ko;q=${korWeight},vn;q=${vnWeight}`;

    const accessToken = store.getters['user/getAccessToken'];
    const hasExplicitTokenHeader = Object.keys(request.headers).some(
      (name) => name.toLowerCase() === USER_TOKEN_HEADER.toLowerCase()
    );
    if (
      typeof accessToken === 'string' &&
      accessToken.length > 0 &&
      typeof request.url === 'string' &&
      RELATIVE_APPLICATION_API.test(request.url) &&
      !hasExplicitTokenHeader
    ) {
      request.headers[USER_TOKEN_HEADER] = accessToken;
    }
    // verboseLanguage(request);

    return request;
  }
  handleSuccess(response) {
    loaded();
    return response;
  }
  handleError(error) {
    loaded();
    return Promise.resolve(error?.response ?? createNetworkErrorResponse(error));
  }

  status = {
    NETWORK_ERROR: NETWORK_ERROR_STATUS,
    OK: 200,
    ERROR: 500,
    NOT_FOUNT: 404
  };

  get(path, params = {}, config = {}) {
    const { paramsSerializer, responseType = 'json', ...requestConfig } = config;
    return this.$axios.request({
      method: 'GET',
      url: path,
      ...requestConfig,
      responseType,
      params,
      paramsSerializer:
        paramsSerializer ||
        ((params) =>
          qs.stringify(params, {
          arrayFormat: 'indices',
          skipNulls: true,
          allowDots: true
        }))
    });
  }

  put(path, payload) {
    return this.$axios.request({
      method: 'PUT',
      url: path,
      responseType: 'json',
      data: payload
      // params: payload,
      // paramsSerializer: (payload) =>
      //   qs.stringify(payload, { arrayFormat: 'repeat' })
    });
  }

  patch(path, payload, options) {
    return this.$axios.request({
      method: 'PATCH',
      url: path,
      responseType: 'json',
      data: payload,
      params: options
    });
  }

  post(path, payload, config = {}) {
    const { responseType = 'json', ...requestConfig } = config;
    return this.$axios.request({
      method: 'POST',
      url: path,
      ...requestConfig,
      responseType,
      data: payload
    });
  }

  delete(path, payload) {
    payload = `${path}?${queryString.stringify(payload)}`;
    return this.$axios.delete(payload);
  }

  queryPost(path, payload) {
    payload = `${queryString.stringify(payload)}`;
    return this.$axios.request({
      method: 'POST',
      url: path,
      responseType: 'json',
      data: payload
    });
  }

  multiPost(path, payload) {
    return this.$axios.request({
      headers: { 'Content-Type': 'multipart/form-data' },
      method: 'POST',
      url: path,
      responseType: 'json',
      data: payload
    });
  }

  getAxios() {
    return this.$axios;
  }
}
let instance;
const initialize = () => {
  if (!instance) instance = new ServiceExec();

  return instance;
};
export default initialize();
